<div class="dialog-container">
  <div class="dialog-header pl-35 mt-20">
    <div class="dialog-header-title">Order Tracking</div>
    <div class="dialog-header-cross m-r-35" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <hr class="hr-line"/>

  <div class="dialog-form">
    <div class="confirm-class">
      <div class="order-content-rc">
        <div class="mt-25 mb-25" style="min-height: 470px" *ngIf="showMap">
          <!-- rider not assigned -->
          <div
            class="map-section"
            *ngIf="
              riderStatus == 'new' ||
              riderStatus == 'planned' ||
              riderStatus == 'ASSIGNING_DRIVER'
            "
          >
            <agm-map [disableDefaultUI]="false" [zoomControl]="false">
              <agm-direction
                [renderOptions]="renderOptions"
                [markerOptions]="markerOptions"
                [origin]="origin"
                [destination]="destination"
              ></agm-direction>
            </agm-map>
          </div>

          <!-- rider not arrived at restaurant -->
          <div
            class="map-section"
            *ngIf="
              riderStatus == 'courier_assigned' ||
              riderStatus == 'courier_departed' ||
              this.riderStatus == 'ON_GOING'
            "
          >
            <agm-map [disableDefaultUI]="false" [zoomControl]="false">
              <agm-marker
                [latitude]="customer.lat"
                [longitude]="customer.lng"
                [markerDraggable]="false"
                [agmFitBounds]="true"
                [iconUrl]="markerUrl"
              ></agm-marker>

              <agm-direction
                [renderOptions]="renderOptions"
                [markerOptions]="markerOptions"
                [origin]="origin"
                [destination]="destination"
              ></agm-direction>
            </agm-map>
          </div>

          <!-- Driver left with package -->
          <div
            class="map-section"
            *ngIf="
              riderStatus == 'parcel_picked_up' ||
              riderStatus == 'courier_arrived' ||
              riderStatus == 'active' ||
              this.riderStatus == 'PICKED_UP'
            "
          >
            <agm-map [disableDefaultUI]="false" [zoomControl]="false">
              <agm-marker
                [latitude]="rest_location.lat"
                [longitude]="rest_location.lon"
                [markerDraggable]="false"
                [agmFitBounds]="true"
                [iconUrl]="markerUrl"
              ></agm-marker>

              <agm-direction
                [renderOptions]="renderOptions"
                [markerOptions]="markerOptions"
                [origin]="origin"
                [destination]="destination"
              ></agm-direction>
            </agm-map>
          </div>

          <!-- Rider Status -->
          <p class="driver-text">{{ riderStatusText }}</p>
          <p class="food-text">{{ foodStatusText }}</p>
          <p class="food-text">Last Updated : {{ lastUpdated }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
